import { useState } from "react";
import { LuPlus } from "react-icons/lu";
import LayoutContentArea from "@/components/layout/LayoutContentArea";
import SystemMessagesTable from "@/components/system-messages/SystemMessagesTable";
import SystemMessageFormPopup from "@/components/system-messages/SystemMessageFormPopup";
import SystemMessagesTabs, {
  SystemMessagesTab,
} from "@/components/system-messages/SystemMessagesTab";
import useSystemMessagesAdmin from "@/components/system-messages/hooks/useSystemMessagesAdmin";
export default function SystemMessagesPage() {
  const [activeTab, setActiveTab] =
    useState<SystemMessagesTab>("liveScheduled");
  const {
    past,
    liveScheduled,
    inactive,
    isLoading,
    saving,
    error,
    popupOpen,
    editingMessage,
    handleEdit,
    handleDelete,
    handleNewMessage,
    handlePopupClose,
    handleSubmit,
  } = useSystemMessagesAdmin();
  const visibleMessages =
    activeTab === "liveScheduled"
      ? liveScheduled
      : activeTab === "past"
        ? past
        : inactive;
  const isInactiveTab = activeTab === "inactive";
  return (
    <LayoutContentArea headingText="System Messages">
      <p
        style={{
          color: "#64748b",
          marginTop: "-1rem",
          marginBottom: "1.5rem",
          maxWidth: "900px",
        }}
      >
        Create and manage messages displayed to CAPSDAC users on their
        dashboard.
      </p>
      {error && (
        <div
          role="alert"
          style={{
            padding: "0.75rem 1rem",
            marginBottom: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #fecaca",
            backgroundColor: "#fef2f2",
            color: "#991b1b",
            fontSize: "0.875rem",
          }}
        >
          {error instanceof Error ? error.message : "Something went wrong"}
        </div>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
          flexWrap: "wrap",
          marginBottom: "1rem",
        }}
      >
        <SystemMessagesTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
          counts={{
            liveScheduled: liveScheduled.length,
            past: past.length,
            inactive: inactive.length,
          }}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleNewMessage}
          disabled={isLoading || saving}
        >
          <LuPlus size={16} aria-hidden="true" />
          New Message
        </button>
      </div>
      {isLoading ? (
        <div
          style={{
            padding: "3rem 1rem",
            textAlign: "center",
            color: "#64748b",
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "0.5rem",
          }}
        >
          Loading messages…
        </div>
      ) : isInactiveTab ? (
        <SystemMessagesTable messages={visibleMessages} />
      ) : (
        <SystemMessagesTable
          messages={visibleMessages}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
      <SystemMessageFormPopup
        show={popupOpen}
        onClose={handlePopupClose}
        onSubmit={handleSubmit}
        initialMessage={editingMessage}
        saving={saving}
      />
    </LayoutContentArea>
  );
}
